import React from 'react';
import {observer} from "mobx-react";
import {GameDurationBox} from "./boxes/game-duration.box";
import {GameDurationLabelBox} from "./boxes/game-duration-label.box";
import {GameDurationValueBox} from "./boxes/game-duration-value.box";
import {TimeSpan} from "@sparkware/app-utils";
import {CyClass} from "../../../../../../common/cy-classes";
import {
    IGameContextViewModel
} from "../../../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {useServices} from "../../../../../react-hooks/use-services.hook";


interface GameDurationComponentProps {
    gameContext: IGameContextViewModel;
}

export const GameDurationComponent: React.FC<GameDurationComponentProps> = observer((props) => {
    const services = useServices()


    const duration = TimeSpan.fromMilliseconds(services.time.now() - props.gameContext.gameSessionData.gameSessionStartDate.getTime());

    return (
        <GameDurationBox>
            <GameDurationLabelBox>
                {services.translation.translate('GAME_DURATION_LABEL')}
            </GameDurationLabelBox>
            <GameDurationValueBox className={CyClass('cy-game-duration-value')}>
                {duration.toHoursMinutesAndSecondsString()}
            </GameDurationValueBox>

        </GameDurationBox>
    );
})